import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// interface FormInterface {
//   from?: Moment;
//   to?: Moment;
//   leaveType: string;
//   type: string;
// }

interface InitialState {
  date: string;
  data: any;
}

const initialState: InitialState = {
  date: "",
  data: null,
};

const attendanceDetailSlice = createSlice({
  name: "attendanceDetail",
  initialState,
  reducers: {
    updateAttendanceDetail: (
      state,
      action: PayloadAction<{ date: string; data: any }>
    ) => {
      //TODO: Define type
      state.date = action.payload.date;
      state.data = action.payload.data;
    },
    resetAttendanceDetail: () => {
      return { ...initialState };
    },
  },
});

export const { updateAttendanceDetail, resetAttendanceDetail } =
  attendanceDetailSlice.actions;

export default attendanceDetailSlice.reducer;
